import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UploadWizardService } from '../wizard.service';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseService } from 'app/services/firebase.service';
import { ProfileService } from '../../../+profile/profile.service';
import { CountriesService } from 'app/services/countries.service';
import { ProjectService } from 'app/services/project.service';

@Component({
  selector: 'upload-wizard-bookformat-density',
  styleUrls: ['../wizard.component.scss', './bookformatDensity.component.scss'],
  templateUrl: './bookformatDensity.component.html',
})
export class UploadWizardBookformatDensityComponent implements OnInit {
  @Input() step;
  @Input() totalSteps;
  @Input() isFinalStep;
  @Input() isOrderSubmitting;
  @Input() isMobile;
  @Input() projectId;
  @Output() next = new EventEmitter();
  @Output() prev = new EventEmitter();
  submitDisabled = false;
  currency;
  country: any;

  promocode;
  promocodeError;
  promocodeModalVisible;

  shoppingLocaionModalVisible;

  constructor(
    public uploadWizardService: UploadWizardService,
    public translate: TranslateService,
    public firebaseService: FirebaseService,
    private profileService: ProfileService,
    private countriesService: CountriesService,
    private projectService: ProjectService,
  ) {
    this.currency = this.uploadWizardService.densities[this.densitySelected].currency;
  }
  ngOnInit(): void {
    this.profileService.get().subscribe((profile: any) => {
      this.country = this.countriesService.get(profile.country_code);
    });
  }

  getBookformatName(index) {
    return `${this.uploadWizardService.bookformats[index].width}x${this.uploadWizardService.bookformats[index].height}`;
  }

  getDensityName(index) {
    const density = this.uploadWizardService.densities[index];
    const min = density.min_page_count,
      max = density.max_page_count;
    return min === max ? `${min}` : `${min}-${max}`;
  }

  get price() {
    return {
      base: this.calculatePrice(),
      discounted: this.calculatePrice(true),
    };
  }

  calculatePrice(discount = false) {
    const density = this.uploadWizardService.densities[this.densitySelected];

    if (discount) {
      return density.discount ? +density.discount['price'] : +density['price'];
    }
    return +density['price'];
  }

  addPromocode() {
    this.promocodeError = undefined;
    this.promocodeModalVisible = true;
  }

  hidePromocodeModal() {
    this.promocodeModalVisible = false;
  }

  hideShoppingLocationModal() {
    this.calculatePrice();
    this.shoppingLocaionModalVisible = false;
  }

  submitPromocode(promocode) {
    this.uploadWizardService.loadDesignOptions(promocode).subscribe(
      designOptions => {
        this.uploadWizardService.applyDesignOptions(designOptions);
        this.projectService.update(this.projectId, {'discount_code': promocode}).subscribe();
        this.hidePromocodeModal();
        this.firebaseService.logEvent('design_request_discount_enter', {
          project_id: this.projectId,
          discount_code: promocode,
        });
      },
      response => {
        this.promocodeError = response.error[0];
      }
    );
  }

  submitShoppingLocationChange() {
    this.uploadWizardService.loadDesignOptions(this.promocode).subscribe(
      designOptions => {
        this.uploadWizardService.applyDesignOptions(designOptions);
        this.uploadWizardService.selectFormat(0);
        this.selectDensity(0);
        this.currency = this.uploadWizardService.densities[this.densitySelected].currency;
        this.profileService.get().subscribe((profile: any) => {
          this.country = this.countriesService.get(profile.country_code);
        });
        this.hideShoppingLocationModal();
      },
      response => {
        this.promocodeError = response.error[0];
      }
    );
  }

  // From Density component

  get densitySelected() {
    return this.uploadWizardService.densities.findIndex(
      density => density.slug === this.uploadWizardService.specs.image_density
    );
  }

  get densityPicUrl() {
    return this.uploadWizardService.densities[this.densitySelected].picture_url;
  }

  public selectDensity(index) {
    const density = this.uploadWizardService.densities[index];
    this.firebaseService.meta.albumPicsVolume = `${this.getDensityName(
      index
    )} pages`;
    this.uploadWizardService.specs.image_density = density.slug;
  }

  submit() {
    this.submitDisabled = true;
    this.firebaseService.logEvent('design_request_density_level_select', {
      project_id: this.projectId,
    });
    this.firebaseService.logEvent('design_request_book_format_select', {
      project_id: this.projectId,
    });
    this.next.emit();
  }
}
